export const form910 = [
  {
    type: "header",
    formnum: "910",
    text: "УПРОЩЕННАЯ ДЕКЛАРАЦИЯ ДЛЯ СУБЪЕКТОВ МАЛОГО БИЗНЕСА",
  },
  { type: "field", ftype: 6, num: "", text: "text", fieldnum: "" },
  { type: "field", ftype: 5, num: "", text: "text", fieldnum: "910header" },
  { type: "field", ftype: 6, num: "", text: "text", fieldnum: "" },
  {
    type: "title",
    text: "Раздел. Исчисление налогов",
  },
  { type: "field", ftype: 6, num: "", text: "text", fieldnum: "" },
  {
    type: "field",
    ftype: 5,
    num: "910.00.001",
    text: "Доход ",
    fieldnum: "F000",
    formulae: "self",
    index: "6",
    // render on getf910F000
  },
  {
    type: "field",
    ftype: 4,
    num: "",
    text: "A доходы, полученные путем безналичных расчетов",
    fieldnum: "F001",
    index: "0",
  },
  {
    type: "field",
    ftype: 4,
    num: "",
    text: "I в том числе, с применением трехкомпонентной системы",
    fieldnum: "F001",
    index: "1",
    formulae: "self",
  },
  {
    type: "field",
    ftype: 4,
    num: "",
    text: "B доходы, полученные путем наличных расчетов",
    fieldnum: "F001",
    index: "2",
  },
  {
    type: "field",
    ftype: 4,
    num: "",
    text: "I в том числе, с применением трехкомпонентной системы",
    fieldnum: "F001",
    index: "3",
    formulae: "self",
  },
  {
    type: "field",
    ftype: 0,
    num: "910.00.002",
    text:
      "в том числе доход от корректировки в соответствии с Законом о трансфертном ценообразовании",
    fieldnum: "F002",
    formulae: "self",
  },
  {
    type: "field",
    ftype: 0,
    num: "910.00.003",
    text: "Среднесписочная численность работников ",
    fieldnum: "F003",
    formulae: "self",
  },
  { type: "field", num: "", text: "text", fieldnum: "" },
  { type: "field", num: "", text: "text", fieldnum: "" },
  {
    type: "field",
    ftype: 0,
    num: "910.00.004",
    text: "Среднемесячная заработная плата на одного работника ",
    fieldnum: "F004",
    formulae: "self",
  },
  {
    type: "field",
    ftype: 0,
    num: "910.00.005",
    text: "Сумма исчисленных налогов (910.00.001*3%)",
    fieldnum: "F005",
  },
  {
    type: "field",
    ftype: 0,
    num: "910.00.006",
    text:
      "Корректировка суммы налогов в соответствии с пунктом 2 статьи 687 Налогового кодекса",
    fieldnum: "F006",
  },
  {
    type: "field",
    ftype: 0,
    num: "910.00.007",
    text: "Сумма налогов после корректировки (910.00.005 - 910.00.006)",
    fieldnum: "F007",
  },
  {
    type: "field",
    ftype: 0,
    num: "910.00.008",
    text:
      "Сумма индивидуального (корпоративного) подоходного налога, подлежащего уплате в бюджет (910.00.007 х 0,5)",
    fieldnum: "F008",
  },
  {
    type: "field",
    ftype: 0,
    num: "910.00.009",
    text:
      "Уменьшение индивидуальным предпринимателем суммы индивидуального подоходного налога, подлежащего уплате в бюджет в соответствии с пунктом 2-1 статьи 687 Налогового кодекса (на сумму 60 000 тенге, но не более чем на 50 процентов от исчисленной суммы подоходного налога) за текущий календарный год.",
    fieldnum: "F009",
  },
  {
    type: "field",
    ftype: 0,
    num: "910.00.010",
    text:
      "Уменьшение индивидуальным предпринимателем суммы индивидуального подоходного налога, подлежащего уплате в бюджет в соответствии с пунктом 2-1 статьи 687 Налогового кодекса (на сумму 60 000 тенге, но не более чем на 50 процентов от исчисленной суммы подоходного налога) за текущий календарный год.",
    fieldnum: "F003",
    formulae: "self",
  },
  {
    type: "field",
    ftype: 0,
    num: "910.00.011",
    text:
      "Сумма индивидуального (корпоративного) подоходного налога, подлежащего уплате в бюджет 910.00.008 - 910.00.010.",
    fieldnum: "F011",
  },
  {
    type: "title",
    text:
      "Раздел. Исчисление социальных отчислений, обязательных пенсионных взносов и взносов на обязательное социальное медицинское страхование за индивидуального предпринимателя ТОЛЬКО ДЛЯ ИП",
  },
  {
    type: "field",
    ftype: 2,
    num: "910.00.012",
    text: "Доход для исчисления социальных отчислений",
    fieldnum: "F012",
  },
  {
    type: "field",
    ftype: 2,
    num: "910.00.013",
    text: "Сумма социальных отчислений к уплате",
    fieldnum: "F013",
  },
  {
    type: "field",
    ftype: 2,
    num: "910.00.014",
    text: "Доход для исчисления обязательных пенсионных взносов",
    fieldnum: "F014",
  },
  {
    type: "field",
    ftype: 2,
    num: "910.00.015",
    text: "Сумма обязательных пенсионных взносов, к уплате",
    fieldnum: "F015",
  },
  {
    type: "field",
    ftype: 2,
    num: "910.00.016",
    text:
      "Сумма взносов на обязательное социальное медицинское страхование, к уплате",
    fieldnum: "F016",
  },
  { type: "field", num: "", text: "text", fieldnum: "", ftype: 6 },
  {
    type: "title",
    text:
      "Раздел. Исчисление индивидуального подоходного налога, социальных отчислений, обязательных пенсионных взносов, обязательных процессиональных пенсионных взносов и отчислений на обязательное социальное медицинское страхование физических лиц",
  },
  { type: "field", num: "", text: "text", fieldnum: "", ftype: 6 },
  {
    type: "field",
    ftype: 2,
    num: "910.00.017",
    text:
      "Сумма индивидуального подоходного налога, подлежащая перечислению в бюджет с доходов граждан Республики Казахстан",
    fieldnum: "F017",
  },
  {
    type: "field",
    ftype: 2,
    num: "910.00.018",
    text:
      "Сумма индивидуального подоходного налога, подлежащая перечислению в бюджет с доходов иностранцев и лиц без гражданства",
    fieldnum: "F018",
  },
  {
    type: "field",
    ftype: 2,
    num: "910.00.019",
    text: "Доходы физических лиц, с которых исчисляются социальные отчисления",
    fieldnum: "F019",
  },
  {
    type: "field",
    ftype: 2,
    num: "910.00.020",
    text: "Сумма социальных отчислений, к уплате",
    fieldnum: "F020",
  },
  {
    type: "field",
    ftype: 2,
    num: "910.00.021",
    text:
      "Доходы работников, с которых удерживаются (начисляются) обязательные пенсионные взносы",
    fieldnum: "F021",
  },
  {
    type: "field",
    ftype: 2,
    num: "910.00.022",
    text: "Сумма обязательных пенсионных взносов, к уплате",
    fieldnum: "F022",
  },
  {
    type: "field",
    ftype: 2,
    num: "910.00.023",
    text:
      "Доходы работников, принимаемых для исчисления обязательных профессиональных пенсионных взносов",
    fieldnum: "F023",
  },
  {
    type: "field",
    ftype: 2,
    num: "910.00.024",
    text: "Сумма обязательных профессиональных пенсионных взносов, к уплате",
    fieldnum: "F024",
  },
  {
    type: "field",
    ftype: 2,
    num: "910.00.025",
    text:
      "Доходы, принимаемые для исчисления взносов и отчислений на обязательное социальное медицинское страхование",
    fieldnum: "F025",
  },
  {
    type: "field",
    ftype: 2,
    num: "910.00.026",
    text:
      "Сумма взносов и отчислений на обязательное социальное медицинское страхование, к уплате",
    fieldnum: "F026",
  },
  { type: "field", num: "", text: "text", fieldnum: "", ftype: 6 },
  {
    type: "title",
    text: "Раздел. Сведения о запасах",
  },
  { type: "field", num: "", text: "text", fieldnum: "", ftype: 6 },
  {
    type: "field",
    ftype: 0,
    num: "910.00.027",
    text: "Запасы:",
    fieldnum: "F027",
    formulae: "self",
    index: 3,
  },
  {
    type: "field",
    ftype: 4,
    num: "",
    text: "A - запасы на начало налогового периода всего",
    fieldnum: "F027",
    index: 0,
  },
  {
    type: "field",
    ftype: 4,
    num: "",
    text: "B - запасы на конец налогового периода всего",
    fieldnum: "F027",
    index: 1,
  },
  {
    type: "field",
    ftype: 4,
    num: "",
    text: "C - приобретено запасов, работ, услуг всего",
    fieldnum: "F027",
    index: 2,
  },
  { type: "field", num: "", text: "text", fieldnum: "", ftype: 6 },
  {
    type: "title",
    text:
      "Раздел. Бизнес-идентификационный номер аппарата акимов городов районного значения, сел, поселков, сельских округов",
  },
  { type: "field", num: "", text: "text", fieldnum: "", ftype: 6 },
  {
    type: "field",
    ftype: 0,
    num: "910.00.028",
    text: "Запасы:",
    fieldnum: "F028",
    formulae: "self",
  },
]
